import { render, staticRenderFns } from "./MtcLabUsers.vue?vue&type=template&id=848ba000&scoped=true&"
import script from "./MtcLabUsers.vue?vue&type=script&lang=js&"
export * from "./MtcLabUsers.vue?vue&type=script&lang=js&"
import style0 from "./MtcLabUsers.vue?vue&type=style&index=0&id=848ba000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848ba000",
  null
  
)

export default component.exports